import { useSelector } from 'react-redux'

export default function Fullpage() {
    const site = useSelector(state => state.siteMaster)

    if (site.fullpage) return site.fullpage
    return null
}